// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"781e157d","453":"13bc135d","553":"86f34dbf","683":"f0324210","977":"29362626"}[chunkId] + ".chunk.js";
};